/* @flow strict */

import { ytRegExp } from '/client/src/utils/youTubeEmbedUrl';
import { viRegExp } from '/client/src/utils/vimeoEmbedUrl';

export const validateVideoUrl = (url: string) => {
  if (url !== undefined || url !== '') {
    const matchY = url.match(ytRegExp);
    const matchV = url.match(viRegExp);

    return !!(matchY || matchV);
  }
};
